export default {
  "topbar": "_topbar_1ohrdq",
  "info": "_info_1ohrdq",
  "warning": "_warning_1ohrdq",
  "error": "_error_1ohrdq",
  "wrapper": "_wrapper_1ohrdq",
  "message": "_message_1ohrdq",
  "icon": "_icon_1ohrdq",
  "close": "_close_1ohrdq"
};